import React from 'react';

export default function PageContainer({ children, background = "" }) {

    return (
        <div style={{padding: 10, background}}>{children}</div>
    )
}